import { render, staticRenderFns } from "./[wig-id].vue?vue&type=template&id=454ad31c"
import script from "./[wig-id].vue?vue&type=script&lang=js"
export * from "./[wig-id].vue?vue&type=script&lang=js"
import style0 from "./[wig-id].vue?vue&type=style&index=0&id=454ad31c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports